import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router';
import { useModal } from 'store/modal';
import CreateEntity from 'components/crud/CreateEntity';
import { buildClientEntity, buildClientUrl } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import SegmentForm from './SegmentForm';
import { IInputs } from '../types';

interface IProps {
  segmentsEntityName: string;
}

const CreateForm: FC<IProps> = ({ segmentsEntityName }) => {
  const { showModal } = useModal();
  const { client } = useActiveClientContext();
  const methods = useForm<IInputs>({
    defaultValues: {
      is_active: true,
    },
  });
  const history = useHistory();

  return (
    <CreateEntity
      entity={segmentsEntityName}
      methods={methods}
      onSuccess={(res: any) => {
        const { id, name } = res.data;
        history.push(buildClientUrl(`/segments/edit/${id}`, client));
        showModal({
          type: 'success',
          content: (
            <>
              Създадохте сегмент&nbsp;
              <span className="font-weight-bold">{name}</span>. Можете да добавите елементи към сегмента.
            </>
          ),
        });
      }}
      queryKey={buildClientEntity(segmentsEntityName, client)}
    >
      {(create: any) => (
        <SegmentForm
          methods={methods}
          handleSubmit={data => create(data)}
          btnLabel="Запази"
          canEdit
          isMultilingual={client?.is_multilingual}
        />
      )}
    </CreateEntity>
  );
};

export default CreateForm;
